function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 18.9,
  y: 36.54,
  width: 94.75,
  height: 59.47,
  rx: 7.26,
  ry: 7.26,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 6
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.9 46.8h92.28v16.62H18.9zM85.61 72.59h17.77v12.78H85.61zM27.8 72.65h31.03v5.17H27.8zM27.8 80.07h18.66v5.17H27.8z"
});

function SvgIconCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 132.54 132.54",
    className: "w-full h-full"
  }, props), _ref, _ref2);
}

export default SvgIconCard;